<content-loader>
    <main class="main-div"
        [ngStyle]="{'overflow': authService.validationResult === ValidationStatus.Valid ? 'auto' : 'hidden'}">

        <div *ngIf="authService.validationResult !== ValidationStatus.Valid && showStartPage" class="start-content">
            <div class="flex-center splash-container">
                <div class="login-content">
                    <div class="logo-bar"></div>
                    <button mat-raised-button type="button" class="prm-btn fs-btn-txt loader-btn" id="sendlogin"
                        [disabled]="loaderService.loader" (click)="checkAuthentication()">
                        <span translate>startButton</span>
                    </button>
                </div>
            </div>
        </div>

        <ng-container *ngIf="!showStartPage && !(launcherUpdateGuard.blocked$ | async)">
            <div *ngIf="authService.validationResult === ValidationStatus.Valid">
                <nav-bar></nav-bar>
            </div>
            <div class="router-container" *ngIf="authService.validationResult !== ValidationStatus.Auth"
                [ngClass]="authService.validationResult === ValidationStatus.Valid ? 'content-wrapper' : ''">
                <router-outlet></router-outlet>
            </div>
        </ng-container>
    </main>
</content-loader>

<mini-loader></mini-loader>